<template>
  <div class="padding-top-4 collection-transaction-view">
    <div class="amount-title">{{$t('message.tableCommon.txnAmount')}}</div>
    <div class="amount-data">
      <span class="amount">{{txnInfo.payinAmount}}</span>
      <el-image class="img" fit="scale-down" :src="getCurrencyImage(txnInfo.payinCurrency) ? require(`@/assets/images/currency/${txnInfo.payinCurrency}.png`) : ''"></el-image>
      <el-tag class="status"
        :type="txnInfo.txnStatus === 'Settled' ? 'success': (txnInfo.txnStatus === 'Rejected' ? 'danger' : 'info')">
        {{getEnantiomericValue(merPayinStatusList, txnInfo.txnStatus)}}
      </el-tag>
    </div>
    <div class="reason" v-if="['Rejected', 'Pending'].indexOf(txnInfo.txnStatus) > -1">
      <i class="iconfont icon-warning"></i>
      <div v-if="txnInfo.txnStatus === 'Rejected'">
        <div class="reason-text">{{$t('message.collection.transactionRejectedTipTitle')}}</div>
        <div class="tip">{{txnInfo.failReason}}</div>
      </div>
      <div v-if="txnInfo.txnStatus === 'Pending'">
        <div class="reason-text">{{$t('message.collection.transactionPendingTipTitle')}}</div>
        <div class="tip">{{$t('message.collection.transactionPendingTipReason')}}</div>
      </div>
    </div>
    <details-component :details-condition="txnDetailCondition">
    </details-component>
  </div>
</template>
<script>
import { getDictionary } from '@/api/common';
import DetailsComponent from '@/components/base-details/details.vue';
import { getEnantiomericValue, initSelectedData } from '@/utils/tools/constant';
import { getCurrencyImage } from '@/utils/tools/currency';
import VaTransactionService from '@/views/collection/api/transaction';

export default {
  components: { DetailsComponent },
  data() {
    return {
      txnId: this.$route.query.id,
      item: {
        currency: 'USD',
      },
      txnDetailCondition: [
        {
          topTitle: 'message.transaction.info',
        },
      ],
      txnInfo: {},
      bizTypeList: [],
      merPayinStatusList: [],
    };
  },
  created() {
    this.txnDetailCondition = [];
    VaTransactionService.getTransactionDetails(this.txnId).then(res => {
      this.txnInfo = res;
      this.txnDetailCondition.push(this.getTransactionTemplate(res));
    });
    getDictionary(['MER_PAYIN_STATUS', 'VA_BIZ_TYPE']).then((res) => {
      this.bizTypeList = initSelectedData(res.VA_BIZ_TYPE);
      this.merPayinStatusList = initSelectedData(res.MER_PAYIN_STATUS);
    }).catch(() => {
    });
  },
  methods: {
    getCurrencyImage,
    getTransactionTemplate(allData) {
      return {
        topTitle: 'message.transaction.info',
        type: 'default',
        showAll: true,
        isDisplayTopState: true,
        titleIcon: require('@/assets/images/transaction/icon_transaction.png'),
        listTemplate: [
          {
            titleBar: { title: 'message.tableCommon.txnTime' },
            key: 'createTime',
          },
          { // payer account name
            titleBar: { title: 'message.collection.payerAccountName' },
            key: 'payerName',
          },
          { // 交易流水号
            titleBar: { title: 'message.tableCommon.txnSerialNumber' },
            key: 'id',
          },
          { // payer account number **
            titleBar: { title: 'message.collection.payerAccountNumber' },
            key: 'payerAccount',
          },
          { // 交易类型
            titleBar: { title: 'message.tableCommon.txnType' },
            key: 'bizType',
            textFunc: (row) => getEnantiomericValue(this.bizTypeList, row.bizType),
          },
          { // virtual account name
            titleBar: { title: 'message.collection.virtualAccountName' },
            key: 'payeeName',
          },
          { // 金额
            titleBar: { title: 'message.index.amount' },
            key: 'payinAmount',
            textFunc: (row) => {
              return `${row.payinAmount} ${row.payinCurrency}`;
            },
          },
          { // virtual account number
            titleBar: { title: 'message.collection.virtualAccountNumber' },
            key: 'payeeAccount',
          },
          { // Fee
            titleBar: { title: 'message.settlement.serviceAmount' },
            key: 'payinFee',
            textFunc: (row) => {
              return `${row.payinFee} ${row.payinCurrency}`;
            },
          },
          { // 状态
            titleBar: { title: 'message.tableCommon.status' },
            key: 'txnStatus',
            textFunc: (row) => getEnantiomericValue(this.merPayinStatusList, this.txnInfo.txnStatus),
          },
          { // setttlement time
            titleBar: { title: 'message.collection.settlementTime' },
            key: 'updateTime',
          },
        ],
        data: allData,
      };
    },
    getEnantiomericValue,
    ...VaTransactionService,
  },
};
</script>
<style lang="scss" scoped>
@import '@/styles/variables.scss';
.collection-transaction-view {
  .amount-title {
    font-size: 14px;
    font-weight: normal;
    line-height: 19px;
  }
  .amount-data {
    display: flex;
    align-items: center;
    padding: 7px 0 18px;
    .amount {
      font-size: 30px;
      font-weight: 800;
      line-height: 41px;
    }
    .img {
      height: 27px;
      margin-left: 15px;
      margin-right: 50px;
    }
  }
  .reason {
    display: flex;
    padding: 22px 20px;
    background: $color-default;
    border-radius: 2px;
    margin-bottom: 30px;
    .iconfont {
      color: #FF3B41;
      font-size: 19px;
      margin-right: 10px;
    }
    .reason-text {
      font-size: 16px;
      font-weight: 800;
      line-height: 22px;
    }
    .tip {
      font-size: 14px;
      font-weight: normal;
      line-height: 19px;
      margin-top: 14px;
    }
  }
  .transaction-info {
    border-top: 1px solid rgba(0,32,63,0.08);
    border-bottom: 1px solid rgba(0,32,63,0.08);
    padding: 20px 0 30px;
    display: flex;
    .icon-transaction {
      font-size: 23px;
      color: #37517E;
      margin-right: 10px;
    }
    .info-wrapper {
      .title {
        font-size: 16px;
        font-weight: 800;
        line-height: 25px;
      }
    }
  }
}
</style>
